module.exports = __webpack_public_path__ + "img/buddy_head-wrinkles.4c24e9df.svg";